// One photo list of the aircraft form (thumbnails with delete, plus an Upload button up to maxCount).
import { Button, Image, Typography, Upload, App as AntdApp } from 'antd';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';

import { uploadFile } from '../../api/endpoints';

export function PhotoUploader({
  label,
  urls,
  onAdd,
  onRemove,
  maxCount,
}: {
  label: string;
  urls: string[];
  onAdd: (url: string) => void;
  onRemove: (url: string) => void;
  maxCount: number;
}) {
  const { message } = AntdApp.useApp();
  return (
    <div>
      <Typography.Text strong>{label}</Typography.Text>
      <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 12 }}>
        {urls.map((u) => (
          <div key={u} style={{ position: 'relative' }}>
            <Image
              src={u}
              width={120}
              height={80}
              style={{ objectFit: 'cover', borderRadius: 6 }}
              preview
            />
            <Button
              size="small"
              danger
              icon={<DeleteOutlined />}
              style={{ position: 'absolute', top: 4, right: 4 }}
              onClick={() => onRemove(u)}
            />
          </div>
        ))}
        {urls.length < maxCount ? (
          <Upload
            accept="image/*"
            maxCount={1}
            showUploadList={false}
            customRequest={async (opt) => {
              try {
                const r = await uploadFile(opt.file as File);
                onAdd(r.url);
                opt.onSuccess?.({} as any);
              } catch (e: any) {
                opt.onError?.(e);
                message.error(e?.response?.data?.message || 'Upload failed');
              }
            }}
          >
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        ) : null}
      </div>
    </div>
  );
}
